import { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeNotification } from '../module/NotificationModule';
import ConfigUtil from '../util/ConfigUtil';

let displayed = [];

const Notification = () => {
    const dispatch = useDispatch();
    const notifications = useSelector(({ notificationState }) => notificationState.notifications);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const storeDisplayed = (id) => (displayed = [...displayed, id]);
    const removeDisplayed = (id) => (displayed = [...displayed.filter((key) => id !== key)]);
    const defaultOptions = useMemo(
        () => ({
            autoHideDuration: 1000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        }),
        [],
    );

    useEffect(() => {
        notifications.forEach((item) => {
            const { key, msg, status, options = {}, dismissed = false } = item;
            let customContainer = {};

            if (dismissed) {
                closeSnackbar(key);
                return;
            }

            if (displayed.includes(key)) return;

            const notificationOptions = {
                ...defaultOptions,
                variant: status,
                ...customContainer,
            };

            enqueueSnackbar(msg, {
                key,
                ...notificationOptions,
                onClose: (event, reason, myKey) => {
                    options.onClose && options.onClose(event, reason, myKey);
                },
                onExited: (e, myKey) => {
                    dispatch(removeNotification(myKey));
                    removeDisplayed(myKey);
                },
            });

            storeDisplayed(key);
        });
    }, [dispatch, notifications, closeSnackbar, enqueueSnackbar, defaultOptions]);

    return null;
};

export default Notification;
